module.exports = __webpack_public_path__ + "static/images/icon-john-lewis.3b6888d2d95456dfaf66cbf5b3f8d3a1.svg";